import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const userValidationSchema = (t: TFunction<'translation', undefined>) => ({
  user: yup
    .object()
    .shape({ id: yup.string().required(t(translations.validation.required())) })
    .required(t(translations.validation.required()))
});

export const userInitialValues = () => {
  return { email: '', firstName: '', lastName: '', course: '', studentID: '', uid: '' };
};
